import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import ProjectsIndex from "./pages/ProjectsIndex";
import ProjectDetail from "./pages/ProjectDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProjectsList from "./pages/admin/ProjectsList";
import ProjectEdit from "./pages/admin/ProjectEdit";
import SiteContentEdit from "./pages/admin/SiteContentEdit";
import LogoEdit from "./pages/admin/LogoEdit";
import LeadsList from "./pages/admin/LeadsList";
import CategoriesAdmin from "./pages/admin/CategoriesAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <Routes>
              {/* Public — Indonesian */}
              <Route path="/" element={<HomePage />} />
              <Route path="/proyek" element={<ProjectsIndex />} />
              <Route path="/proyek/:slug" element={<ProjectDetail />} />

              {/* Public — English */}
              <Route path="/en" element={<HomePage />} />
              <Route path="/en/projects" element={<ProjectsIndex />} />
              <Route path="/en/projects/:slug" element={<ProjectDetail />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="projects" element={<ProjectsList />} />
                <Route path="projects/new" element={<ProjectEdit />} />
                <Route path="projects/:id" element={<ProjectEdit />} />
                <Route path="content" element={<SiteContentEdit />} />
                <Route path="categories" element={<CategoriesAdmin />} />
                <Route path="leads" element={<LeadsList />} />
                <Route path="logo" element={<LogoEdit />} />
              </Route>
            </Routes>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
